import ds from 'designsystem';
import { media } from 'designsystem/index';

import Header4 from 'elements/Header4';

const ArticleTitle = Header4.extend`
  ${media.desktop`
    margin-bottom: ${ds.get('metrics.xs')};
    color: #2A2A2A;
  `};
`;

export default ArticleTitle;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/ArticleSlide/Title.jsx